// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fYbGO3Dl0VXZxPGlCxQx{position:relative}.BU83NfpO8VqmaA67e6F_{align-items:center;background:#024cbc;border-radius:5px;box-shadow:0 3px 5px 0 rgba(0,0,0,.15);color:#fff;cursor:pointer;display:flex;height:40px;justify-content:center;margin:35px 0;order:0;position:relative;width:40px}.BU83NfpO8VqmaA67e6F_:hover{background:#052b52;color:#4ee4b3}.BU83NfpO8VqmaA67e6F_:hover svg g{stroke:#4ee4b3}.JAR8Qz1pjvHvRMB6yjIw{left:11px;position:absolute;top:10px}@media screen and (max-width: 767px){.JAR8Qz1pjvHvRMB6yjIw{top:7px}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controlPanel": `fYbGO3Dl0VXZxPGlCxQx`,
	"homeIconWrapper": `BU83NfpO8VqmaA67e6F_`,
	"homeIcon": `JAR8Qz1pjvHvRMB6yjIw`
};
module.exports = ___CSS_LOADER_EXPORT___;
